import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, message, Typography, Spin } from 'antd';
import { UserOutlined, DollarOutlined } from '@ant-design/icons';
import { checkBalance, addBalance, processPayment, checkPaymentStatus } from '../../services/api';
import UPIPayment from './UPIPayment';

const { Title, Text } = Typography;

const DomainPaymentForm = ({ domain, price, withDubleu=false, onSuccess, onPaymentSuccess, onCancel }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [userBalance, setUserBalance] = useState(0);
  const [showAddFunds, setShowAddFunds] = useState(false);
  const [upiDetails, setUpiDetails] = useState({})
  const [paymentStatus, setPaymentStatus] = useState('');

  useEffect(() => {
    fetchUserBalance();
  }, [domain, price]);

  useEffect(() => {
    const notes = withDubleu ? `Purchase of domain ${domain} + Dubleu website builder` : `Purchase of domain ${domain}`; 
    const paymentDetails = {
        payeeAddress: "sanmayakumar@ybl", //"865896880@ybl",
        payeeName: "Sanmaya",
        amount: price,
        transactionNote: notes,
        currency: "INR"
    };
    setUpiDetails(paymentDetails)
  }, [domain, price, withDubleu]);

  const fetchUserBalance = async () => {
    try {
      const balance = await checkBalance();
      setUserBalance(balance);
    } catch (error) {
      console.error('Error fetching balance:', error);
      message.error('Failed to fetch current balance.');
    }
  };

  const handlePaymentOld = async () => {
    setLoading(true);
    try {
      if (userBalance < price) {
        message.error('Insufficient balance. Please add funds.');
        setShowAddFunds(false);
        return;
      }

      // Here we just call onSuccess, actual registration is handled in parent component
      onSuccess();
    } catch (error) {
      console.error('Error processing payment:', error);
      message.error('Failed to process payment. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  const handlePayment = async () => {
    setLoading(true);
    try {
      if (userBalance < price) {
        message.error('Insufficient balance. Please add funds.');
        setShowAddFunds(false);
        return;
      }

      // Process payment through backend
      const paymentResult = await processPayment({
        amount: price,
        domainName: domain,
        paymentType: 'BALANCE' // or any other payment type you might support
      });

      if (paymentResult.success) {
        message.success('Payment processed successfully!');
        onPaymentSuccess(paymentResult.paymentId); // Pass payment ID back to parent
      } else {
        throw new Error(paymentResult.message || 'Payment failed');
      }
    } catch (error) {
      console.error('Error processing payment:', error);
      message.error('Failed to process payment. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleAddFunds = async (values) => {
    setLoading(true);
    try {
      await addBalance(values.amount);
      message.success('Funds added successfully!');
      await fetchUserBalance();
      setShowAddFunds(false);
      form.resetFields();
    } catch (error) {
      console.error('Error adding funds:', error);
      message.error('Failed to add funds. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  const handlePaymentCreated = (paymentId) => {
    // Just store the payment ID at this point
    setPaymentStatus('created');
  };

  const handlePaymentComplete = async (paymentId) => {
    setPaymentStatus('verifying');
    try {
      // Start polling for payment status
      let attempts = 0;
      const maxAttempts = 30; // 1 minute with 2-second intervals
      const pollInterval = 2000;

      const checkPayment = async () => {
        if (attempts >= maxAttempts) {
          message.error('Payment verification timeout. Please try again.');
          return;
        }

        const status = await checkPaymentStatus(paymentId);
        
        if (status.verified) {
          setPaymentStatus('verified');
          message.success('Payment verified! Processing domain registration...');
          onPaymentSuccess(paymentId);
        } else if (status.failed) {
          message.error('Payment verification failed. Please try again.');
        } else {
          attempts++;
          setTimeout(checkPayment, pollInterval);
        }
      };

      await checkPayment();
    } catch (error) {
      console.error('Error verifying payment:', error);
      message.error('Failed to verify payment. Please try again.');
    }
  };

  

  return (
    <Card title={<Title level={4}>Domain Registration Payment</Title>}>
      <Spin spinning={loading}>
        <Text strong>Domain: {domain}</Text>
        {/*<br />
        <Text strong>Price: ₹{price.toFixed(2)}</Text>
        <br />
        <Text strong>Your Balance: ₹{userBalance.toFixed(2)}</Text>
        <br />*/}
        <br />
        <UPIPayment 
          payeeAddress={upiDetails.payeeAddress}
          payeeName={upiDetails.payeeName}
          amount={price}
          domainName={domain}
          transactionNote={upiDetails.transactionNote}
          onPaymentCreated={handlePaymentCreated}
          onPaymentComplete={handlePaymentComplete}
        />
        {/*userBalance >= price ? (
          <Button type="primary" onClick={handlePayment} block>
            Pay and Register
          </Button>
        ) : (
          <Text type="warning">Insufficient balance. Please add funds.</Text>
        )*/}

        <br />
        <br />

        {(showAddFunds) && (
          <Form form={form} onFinish={handleAddFunds} layout="vertical">
            <Form.Item
              name="amount"
              label="Amount to Add"
              rules={[{ required: true, message: 'Please enter an amount' }]}
            >
              <Input prefix={<DollarOutlined />} type="number" min={0.01} step={0.01} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Add Funds
              </Button>
            </Form.Item>
          </Form>
        )}

        {/*<Button onClick={onCancel} block>Cancel</Button>*/}
      </Spin>
    </Card>
  );
};

export default DomainPaymentForm;